export default function Setting() {
  return (
    <div>setting</div>
  )
}